import { axios, talentAxios } from '@/utils/request';

let Api = {
  paperDetail: '/pub/paper/', //论文详情
  patentDetail: '/pub/patent/', //专利详情
  projectDetail: '/pub/project/', //获取项目详情

  getScholarDetail: '/scholar/detail/', // 获取人才详情-基本信息
  getScholarPaper: '/outer-api/scholar/pub/', // 获取人才详情-论文
  getScholarPatents: '/outer-api/scholar/patents/', // 获取人才详情-专利
  getScholarProject: '/outer-api/scholar/projects/', // 获取人才详情-项目
  getScholarCitedAuthor: '/outer-api/scholar/high-citation-cited-author/', // 人才详情-被引作者中的高被引作者，默认引用数超过10000
  highCitedSummary: '/outer-api/academic/ability/high-cited-summary?scholarId=', //人才详情-被引作者中的高被引作者，默认引用数超过10000
  getScholarCitedAuthorTags: '/outer-api/scholar/cited-author-tags-site/', // 人才详情-被引作者荣誉标签
  getScholarCoInfo: '/outer-api/scholar/co-info/', //人才详情-人才触达
  getScholarRelation: '/outer-api/scholar/relation/', //人才详情-科研关系
  getScholarWord: '/outer-api/scholar/research-word/', //人才详情-研究热词、
  getScholarInterests: '/outer-api/scholar/interests/', //人才详情-研究兴趣
  getScholarTrend: '/outer-api/scholar/trend?', // 人才详情-领域前沿度分析
  getScholarChordData: '/outer-api/scholar/chord-data?', // 人才详情-和旋图
  syncGoogleData: '/outer-api/scholar/syncGoogleData/', // 刷新成果
  citeReport: '/outer-api/report/citeReport', // 引文报告
  pubStatistic: '/outer-api/academic/ability/pub-statistic?scholarId=', // 论文分析
  domainRank: '/outer-api/academic/ability/domain-rank?scholarId=', // 领域排名
  citedStatistic: '/outer-api/academic/ability/pub-cited-statistic?scholarId=', // 每年被引用量
  getCoPatentList: '/outer-api/scholar/co-patent-list',
  getCoPaperList: '/outer-api/scholar/co-paper-list',

  getFindPaperList: '/outer-api/global-search/findPaperList', // 成果-获取论文列表
  getFindPatentList: '/outer-api/global-search/findPatentList', // 成果-获取专利列表
};

// 成果-获取专利列表
export const postFindPatentListApi = (params) => {
  return talentAxios.post(Api.getFindPatentList, params);
};

// 成果-获取论文列表
export const postFindPaperListApi = (params) => {
  return talentAxios.post(Api.getFindPaperList, params);
};


// 获取论文详情
export const getPaperDetailApi = (id) => {
  return axios.get(Api.paperDetail + id + '/new');
};
// 获取专利详情
export const getPatentDetailApi = (id) => {
  return axios.get(Api.patentDetail + id + '/new');
};
// 获取项目详情
export const getProjectDetailApi = (id) => {
  return axios.get(Api.projectDetail + id);
};

export const getCoPaperListApi = (params) => {
  return talentAxios.post(Api.getCoPaperList, params);
};

export const getCoPatentListApi = (params) => {
  return talentAxios.post(Api.getCoPatentList, params);
};

export const citeReportApi = (params) => {
  return talentAxios.get(Api.citeReport, { params });
};

export const citedStatisticApi = (scholarId) => {
  return talentAxios.get(Api.citedStatistic + scholarId);
};

export const domainRankApi = (scholarId) => {
  return talentAxios.get(Api.domainRank + scholarId);
};

export const pubStatisticApi = (scholarId) => {
  return talentAxios.get(Api.pubStatistic + scholarId);
};

export const syncGoogleDataApi = (scholarId) => {
  return talentAxios.get(Api.syncGoogleData + scholarId);
};

export const getScholarDetailApi = (scholarId) => {
  return axios.get(Api.getScholarDetail + scholarId);
};

export const getScholarPaperApi = (scholarId, params) => {
  return talentAxios.get(Api.getScholarPaper + scholarId, { params });
};

export const getScholarPatentsApi = (scholarId, params) => {
  return talentAxios.get(Api.getScholarPatents + scholarId, { params });
};

export const getScholarProjectsApi = (scholarId, params) => {
  return talentAxios.get(Api.getScholarProject + scholarId, { params });
};

export const getScholarCitedAuthorApi = (scholarId) => {
  return talentAxios.get(Api.getScholarCitedAuthor + scholarId);
};

export const getScholarCitedAuthorTagsApi = (scholarId) => {
  return talentAxios.get(Api.getScholarCitedAuthorTags + scholarId);
};

export const getScholarCoInfoApi = (scholarId, params) => {
  return talentAxios.get(Api.getScholarCoInfo + scholarId, { params });
};

export const getScholarRelationApi = (scholarId, params) => {
  return talentAxios.get(Api.getScholarRelation + scholarId, { params });
};
export const getScholarWordApi = (scholarId) => {
  return talentAxios.get(Api.getScholarWord + scholarId);
};
export const getScholarInterestsApi = (scholarId) => {
  return talentAxios.get(Api.getScholarInterests + scholarId);
};

export const getScholarTrendApi = (scholarId) => {
  return talentAxios.get(Api.getScholarTrend + scholarId);
};

export const getScholarChordDataApi = (params) => {
  return talentAxios.get(Api.getScholarChordData + params);
};
